var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getter_ajax_dialog.show && _vm.getter_ajax_dialog.loading)?_c('v-progress-circular',{staticClass:"preloader-progress",attrs:{"indeterminate":"","color":"primary"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }